import Class from '@/Class';
import type ViewFactory from '@/Factories/ViewFactory';

export default class ViewFactoryTuple extends Class {

    public view: JQuery<HTMLElement>;
    public factory: ViewFactory;

    constructor(factory: ViewFactory, $view: JQuery) {
        super();

        this.factory = factory;
        this.view = $view;

        this.isDisposable = true;
    }
}